import * as constants from './constants';

export function fetchDishes(status) {
  // console.log(status,"action")
  return {
    type: constants.FETCH_DISHES,
    payload: status
  };
}
export function fetchDishesDone(dishes) {
  return {
    type: constants.FETCH_DISHES_DONE,
    payload: dishes
  };
}
export function fetchDishesFail(error) {
  return {
    type: constants.FETCH_DISHES_FAIL,
    payload: error
  };
}

export function fetchExcludedDishes() {
  return {
    type: constants.FETCH_EXCLUDED_DISHES
  };
}
export function fetchExcludedDishesDone(dishes) {
  return {
    type: constants.FETCH_EXCLUDED_DISHES_DONE,
    payload: dishes
  };
}
export function fetchExcludedDishesFail(error) {
  return {
    type: constants.FETCH_EXCLUDED_DISHES_FAIL,
    payload: error
  };
}

export function fetchDish(formulaCode,actionType) {
  return {
    type: constants.FETCH_DISH,
    payload: formulaCode,
    actionType:actionType
  };
}
export function fetchDishDone(dish) {
  return {
    type: constants.FETCH_DISH_DONE,
    payload: dish
  };
}
export function fetchDishFail(error) {
  return {
    type: constants.FETCH_DISH_FAIL,
    payload: error
  };
}

export function excludeDishes(formulaCodes) {
  return {
    type: constants.EXCLUDE_DISHES,
    payload: formulaCodes
  };
}
export function excludeDishesDone(dishes) {
  return {
    type: constants.EXCLUDE_DISHES_DONE,
    payload: dishes
  };
}
export function excludeDishesFail(error) {
  return {
    type: constants.EXCLUDE_DISHES_FAIL,
    payload: error
  };
}

export function includeDishes(formulaCodes) {
  return {
    type: constants.INCLUDE_DISHES,
    payload: formulaCodes
  };
}
export function includeDishesDone(dishes) {
  return {
    type: constants.INCLUDE_DISHES_DONE,
    payload: dishes
  };
}
export function includeDishesFail(error) {
  return {
    type: constants.INCLUDE_DISHES_FAIL,
    payload: error
  };
}
